<template>
  <div>
    <!-- Auto play -->
    <v-layout row wrap class="mt-3">
      <v-flex xs12 sm12>
        <v-checkbox
          class="mt-0"
          v-model="event_configuration_local.auto_play"
          :label="$t('screener.save.form.auto_play')"
          @change="inputHandler"
          color="primary"
        >
          <template v-slot:append>
            <v-tooltip top color="white">
              <template v-slot:activator="{on}">
                <v-icon v-on="on">mdi-information-outline</v-icon>
              </template>
              <div
                class="grey--text text--darken-3 body-1"
              >{{ $t('screener.save.form.auto_play.tooltip') }}</div>
            </v-tooltip>
          </template>
        </v-checkbox>
        <!-- No Skip -->
        <v-checkbox
          class="mt-0"
          :label="$t('screener.save.form.no_skip')"
          v-model="event_configuration_local.no_skip"
          @change="inputHandler"
          color="primary"
        >
          <template v-slot:append>
            <v-tooltip top color="white">
              <template v-slot:activator="{on}">
                <v-icon v-on="on">mdi-information-outline</v-icon>
              </template>
              <div
                class="grey--text text--darken-3 body-1"
              >{{ $t('screener.save.form.no_skip.tooltip') }}</div>
            </v-tooltip>
          </template>
        </v-checkbox>
        <!-- No pause -->
        <v-checkbox
          class="mt-0"
          :label="$t('screener.save.form.no_pause')"
          v-model="event_configuration_local.no_pause"
          @change="inputHandler"
          color="primary"
        >
          <template v-slot:append>
            <v-tooltip top color="white">
              <template v-slot:activator="{on}">
                <v-icon v-on="on">mdi-information-outline</v-icon>
              </template>
              <div
                class="grey--text text--darken-3 body-1"
              >{{ $t('screener.save.form.no_pause.tooltip') }}</div>
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
          class="mt-0"
          :label="$t('screener.save.form.movie_switching_allowed')"
          v-model="event_configuration_local.movie_switching_enabled"
          @change="inputHandler"
          color="primary"
        >
          <template v-slot:append>
            <v-tooltip top color="white">
              <template v-slot:activator="{on}">
                <v-icon v-on="on">mdi-information-outline</v-icon>
              </template>
              <div
                class="grey--text text--darken-3 body-1"
              >{{ $t('screener.save.form.no_pause.tooltip') }}</div>
            </v-tooltip>
          </template>
        </v-checkbox>
      </v-flex>
    </v-layout>
    <div class="py-2">
      <h3 class="grey--text text--darken-3" v-html="$t(`${eventPrefix}.save.event.level.configuration.tooltip`)"></h3>
      <!-- Full screen mode -->
      <v-layout row wrap class="mt-3">
        <v-flex xs12 sm12>
          <v-checkbox
            class="mt-0"
            v-model="event_configuration_local.is_full_screen_mode"
            :label="$t('screener.save.form.full_screen_mode')"
            @change="inputHandler"
            color="primary"
          >
            <template v-slot:append>
              <v-tooltip top color="white">
                <template v-slot:activator="{on}">
                  <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <div
                  class="grey--text text--darken-3 body-1"
                >{{ $t('screener.save.form.full_screen_mode.tooltip') }}</div>
              </v-tooltip>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventConfiguration",
  model: {
    prop: "event_configuration",
    event: "input"
  },
  props: {
    event_configuration: {
      type: Object
    }
  },
  data() {
    return {
      event_configuration_local: {
        auto_play: true,
        no_skip: false,
        no_pause: false,
        movie_switching_enabled: true,
        is_full_screen_mode: false
      }
    };
  },
  computed: {
    eventPrefix() {
      return this.$route.query && this.$route.query.isVodEvent
        ? "vod"
        : "screener";
    },
  },
  watch: {
    event_configuration: {
      handler() {
        this.init();
      },
      deep: true
    }
  },
  methods: {
    init() {
      if (!this.event_configuration) {
        return;
      }
      this.event_configuration_local = this.event_configuration;
    },
    inputHandler() {
      this.$emit("input", this.event_configuration_local);
    }
  }
};
</script>

<style></style>
